module.exports = __webpack_public_path__ + "img/checkIn-file.56e83e78.svg";